<template>
  <div>
    <myHeader />
    <!-- 订阅部分 -->
    <div class="bg">
      <h1 style="font-size:26px">软件订阅</h1>
      <div class="card-container">
        <div @click="selectCard(index)" v-for="(card, index) in cards" :key="index" class="card" :style="{
          border: card.isSelected ? '4px solid #2a82e4' : '0px solid #2a82e4',
          boxShadow: card.isSelected ? '5px 5px 20px #007bff' : 'none',
        }">
<!--          <div class="card-header">{{ card.title }}</div>-->
          <div class="card-icon" :style="{ backgroundColor: card.bgColor }">
            {{ card.title }}
          </div>
          <div class="card-price">
            <span>{{ card.price }}</span>
          </div>
        </div>
      </div>
      <div class="feedback-container">
        <p style="font-size:12px">
          请填入最让您满意的工作人员姓名，这将会对TA产生正向激励，希望这样能给您带来更好的学习与使用体验。
        </p>

        <div class="input-group">
          <p>姓名:<input type="text" v-model="workName" placeholder="工作人员姓名 (选填)" /></p>
          <p>数量:<input @input="validateInput" type="number" v-model="selectedNum" placeholder="请输入数量" /></p>
          <p><button @click="handleSubscribe" :disabled="btnDisabled">立即订阅</button></p>
        </div>
      </div>
    </div>

    <!-- 轮播图部分 -->
    <div class="bg1">
      <div>
        <h1 class="headtext" style="font-size:26px">
          登录您的<span class="colorb">hecoos会员账号</span><br />可体验到
        </h1>
      </div>

      <!-- vant轮播 -->
      <div class="swipe-container">
        <van-swipe :autoplay="5000" :circular="true" ref="mySwipe" :show-indicators="false">
          <van-swipe-item v-for="(image, index) in slides" :key="index">
            <img :src="image.image" alt="轮播图图片" />
            <p class="image-desc">{{ image.desc }}</p>
          </van-swipe-item>
        </van-swipe>

        <!-- 下方切换按钮 -->
        <div class="arrow-wrapper">
          <div class="arrow-left" @click="prev">
            <button class="prev-button">&#60;</button>

          </div>
          <div class="arrow-right" @click="next">
            <button class="next-button">&#62;</button>
          </div>
        </div>
      </div>
    </div>
    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import myTest from "@/components/mobile/myTest.vue";
import { VipSubscribe } from "@/api/api";
import { Message } from "element-ui";
export default {
  components: { myHeader, myFooter, myTest },
  data() {
    return {
      btnDisabled: false,
      cards: [
        {
          title: "周",
          imgsrc1: require("@/asset/SoftwareSubscriptions/week.svg"),
          iconClass: "fa-solid fa-bicycle",
          price: "¥98.00",
          subtext: "Per week",
          btnClass: "",
          bgColor: "#848A95 ",
          isSelected: true,
          orderType: 3,
          num: 1,
        },
        {
          title: "月",
          imgsrc1: require("@/asset/SoftwareSubscriptions/mouth.svg"),
          iconClass: "fa-solid fa-car",
          price: "¥198.00",
          subtext: "Per month",
          btnClass: "active",
          bgColor: "#147CF5",
          isSelected: false,
          orderType: 1,
          num: 1,
        },
        {
          imgsrc1: require("@/asset/SoftwareSubscriptions/year.svg"),
          title: "年",
          iconClass: "fa-solid fa-rocket",
          price: "¥1998.00",
          subtext: "Per year",
          btnClass: "dark",
          bgColor: "#0B162B",
          orderType: 2,
          isSelected: false,
          num: 1,
        },
      ],
      currentIndex: 0,
      workName: '',
      orderType: 3,  //存储对应的 周月年
      staffName: '',   //存储姓名
      selectedNum: 1,  // 新增变量，用于存储选中卡片的数量
      slides: [
        {
          image:"https://download.hecoos.com/enlightv/2025-37/28b0215286c7d1e1c1907b0a918d8b81.png",
          desc: "三维场景预演、投影仿真、灯光效果编辑与导播设计",
        },
        {
          image:"https://download.hecoos.com/enlightv/2025-37/5b9aa1b57aec71f2b1b8d35047e0ce57.png",
          desc: "2*2K测试信号输出(带水印) 外部设备控制(间歇性中断)",
        },
        {
          image:
              "https://download.hecoos.com/enlightv/2025-17/9c609c133d5ff2e733e08934ef8167c5.png",
          desc: "节目与控制指令编辑 项目现场调试",
        },
        {
          image:
              "https://download.hecoos.com/enlightv/2025-35/02a5e47e63883b0428b059fb2ae7357b.jpg",
          desc: "作为项目测试端应用可脱离hecoos服务器使用",
        },
      ],
    };
  },
  created() {
    // this.MembershipSubscription()
    if (localStorage.getItem('orderMsg')) {
      const msg = JSON.parse(localStorage.getItem('orderMsg'));
      // 重新选中年月日
      // if (msg.orderType === 3) {
      //   this.cards[0].isSelected = true;
      //   this.cards[0].num = msg.num;
      // } else if (msg.orderType === 1) {
      //   this.cards[1].isSelected = true;
      //   this.cards[1].num = msg.num;
      // } else if (index === 2) {
      //   this.cards[2].isSelected = true;
      //   this.cards[2].num = msg.num;
      // }
      // console.log(msg);
      this.cards.forEach((item, index) => {
        if (item.orderType == msg.orderType) {
          this.orderType = msg.orderType;
          item.isSelected = true;
          item.num = msg.num;
        } else {
          item.isSelected = false;
        }
      })
      // 重新赋值之前选择的数量
      this.selectedNum = msg.num
      localStorage.removeItem('orderMsg');
    }
    if (this.$route.query.orderType) {
      let orderType = this.$route.query.orderType
      this.cards.forEach((item, index) => {
        if (item.orderType == orderType) {
          this.orderType = orderType;
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }
      })
    }
  },
  methods: {
    validateInput() {
      // 移除所有非数字字符
      let value = this.selectedNum.toString().replace(/[^0-9]/g, '');

      // 转换为数字
      let num = Number(value);

      // 处理空值情况
      if (value === '') {
        this.selectedNum = '';
        return;
      }

      // 限制范围
      if (num < 1) {
        num = 1;
      } else if (num > 99) {
        num = 99;
      }

      this.selectedNum = num;
    },

    prev() {
      this.$refs.mySwipe.prev();
    },
    next() {
      this.$refs.mySwipe.next();
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },

    // 选中对应的价格
    selectCard(index) {
      this.cards.forEach((card, i) => {
        card.isSelected = i === index;
      });
      // 存储对应的数字 1, 2, 3
      if (index === 0) {
        this.orderType = 3;
      } else if (index === 1) {
        this.orderType = 1;
      } else if (index === 2) {
        this.orderType = 2;
      }
      // console.log(this.orderType)
      this.selectedNum = this.cards[index].num; // 更新选中卡片的数量
      // console.log(this.selectedNum);
    },

    handleSubscribe() {
      const orderMsg = {
        orderType: this.orderType,
        num: this.selectedNum,
      }
      if (!this.orderType) {
        Message.error('请先选择订阅类型');
        return;
      }
      if (this.selectedNum <= 0) {
        Message.error('订阅数量必须大于 0');
        return;
      }
      if (!localStorage.getItem('token')) {
        localStorage.setItem('orderMsg', JSON.stringify(orderMsg))
        Message.error('请先登录')
        setTimeout(() => {
          this.$router.push('/login')
        }, 800)
        return
      }

      const type = this.orderType;
      const num = this.selectedNum;
      this.MembershipSubscription(type, num);
    },

    MembershipSubscription(type, num) {
      this.btnDisabled = true
      let postData = {
        orderType: type,
        num: num,
        // staffName: this.staffName  //姓名不传
      };

      // console.log(postData);

      VipSubscribe(postData).then((res) => {
        if (res.code === 200) {
          this.btnDisabled = false
          // 创建一个新的 div 元素来插入表单
          const formDiv = document.createElement("div");
          formDiv.innerHTML = res.data.buyFormHtml;
          console.log(res.data)
          document.body.appendChild(formDiv);
          // 自动提交表单
          const form = formDiv.querySelector("form");
          if (form) {
            form.submit();
          }
        } else {
          this.btnDisabled = false
          console.error("订阅失败:", res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px){
  .swipe-container {
  position: relative;

}

.swipe-container img {
  width: 100%;
}

.prev-button,
.next-button {
  padding: 8px 12px;
  background-color: #1B1818;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s ease;
}

.prev-button:active,
.next-button:active {
  background-color: #343334;
}

.arrow-wrapper {


  display: flex;
  justify-content: right;
  padding: 20px 0;
}

.arrow-left,
.arrow-right {
  cursor: pointer;
  margin-right: 10px;
  /* 按钮之间添加间距 */
  /* 可进一步设置箭头的样式，如颜色、大小等 */
}

.bg {
  background: black;
}

.bg h1 {
  font-size: 50px !important;
  text-align: center;
  color: white;
  padding: 35px 43px;
}

.card-container {
  padding: 0px 43px;
}

.card {
  background-color: #fff;
  border-radius: 5px;
  padding:12px 5px;
  text-align: center;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  margin: 30px 0;
  height: 200px;
}

.card:nth-child(1) {
  margin: 0px 0px 0 0;
}

.card-header {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 48px;
  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-icon {

  width: 84px !important;
  height: 84px !important;
  border-radius: 50%;
  background-color: #007bff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 35px !important;
  margin:18px auto 30px auto;

}

.card-icon img {
  width: 25px;
  height: 25px;
  position: relative;
  top: 5px;
}

.card-icon i {
  font-size: 20px;
}

.card-price {
  font-size: 20px;
  font-weight: 400;

  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-price span:last-child {
  font-size: 26px !important;
}

.card-subtext {
  color: #777;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;

  text-align: center;
  vertical-align: top;
}

.subscribe-btn {
  padding: 5px 30px;
  border: 1px solid #ccc;
  border-radius: 20px;
  background-color: white;
  cursor: pointer;
  text-align: center;
  margin: 25px 0;
}

.subscribe-btn:hover {
  color: white;
  background-color: #ccc;
}

.active {
  background-color: #147cf5;
  color: white;
  border-color: #147cf5;
}

.active:hover {
  background-color: white;
  color: #007bff;
}

.dark {
  background-color: #333;
  color: white;
  border-color: #333;
}

.dark:hover {
  color: #333;
  background-color: white;
}

.feedback-container {
  font-family: YourFontName2;
  padding: 10px 43px;
}

.feedback-container p {
  font-size: 20px !important;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 25px !important;
  vertical-align: top;
  font-family: YourFontName2;
}

.kk {
  color: #147cf5;
  border: 1px solid gray;
  width: 50px;
  height: 30px;
  text-align: left;
  margin: 0;
  background-color: #e5e5e5;
  color: black;
  border-radius: 10px;
  padding: 0px 50px 0px 10px;
  vertical-align: middle;
}

.input-group {
  margin-top: 20px;
}

.input-group input {
  padding: 10px 100px 10px 5px !important;
  color: white;
  background-color: #333333;
  border-radius: 2px 0px 0px 2px;
  border: none;
  border-radius: 2px;
  color: gray;
  margin: 10px 5px;
}

.input-group button {
  padding: 5px 15px 5px 15px;
  background-color: #147cf5;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 30px !important;
  width: 350px !important;
  height: 50px !important;
  margin: 10px 0;
}

.input-group button:hover {
  color: #147cf5;
  background-color: white;
}

.login-container {
  text-align: center;
  color: white;
  background-color: black;
  padding: 100px 0;
  width: 80%;
  margin: 0 auto;
}

.bg1 {
  background-color: black;
  padding: 0px 43px;
}

.headbanner h1 {
  font-size: 50px;
  text-align: center;
  color: white;
  padding: 200px 0px 0px 0px;
}

.headbanner p {
  font-size: 16px;
  text-align: center;
  color: white;
  padding: 50px 0px 100px 0px;
}

.headbanner {
  text-align: center;
}

.slider {
  overflow: hidden;
}

.slider-wrapper {
  display: flex;

  transition: transform 1s ease;
}

.slide p {
  color: gray;
  font-size: 15px;
  font-family: YourFontName2;
  text-align: left;
  padding: 20px 0;
}

.slide img {
  width: auto;
  object-fit: cover;
}

.headtext {
  color: white;
  font-size: 45px !important;
  text-align: center;
  vertical-align: top;
  padding: 30px 0;
}

.headtext span {
  background: linear-gradient(to left,
      rgba(76, 142, 212, 1),
      rgba(128, 99, 220, 1),
      rgba(173, 63, 226, 1));
  /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
  background-clip: text;
  /*将设置的背景颜色限制在文字中*/
  -webkit-text-fill-color: transparent;
  /*给文字设置成透明*/
}

.colorb {
  color: #6600ff;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 15px;
  border-radius: 50%;
}

.image-desc {
  padding-top: 15px;
  font-size: 18px !important;
  color: #85858A;
}

.arrow-button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: #343334;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
  transition: all 0.5s ease;
}

.arrow-button:hover {
  background-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.parents {
  text-align: right;
  height: 50px;
}
}
.swipe-container {
  position: relative;

}

.swipe-container img {
  width: 100%;
}

.prev-button,
.next-button {
  padding: 8px 12px;
  background-color: #1B1818;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px !important;
  transition: background-color 0.3s ease;
}

.prev-button:active,
.next-button:active {
  background-color: #343334;
}

.arrow-wrapper {


  display: flex;
  justify-content: right;
  padding: 20px 0;
}

.arrow-left,
.arrow-right {
  cursor: pointer;
  margin-right: 10px;
  /* 按钮之间添加间距 */
  /* 可进一步设置箭头的样式，如颜色、大小等 */
}

.bg {
  background: black;
}

.bg h1 {
  font-size: 28px;
  text-align: center;
  color: white;
  padding: 35px 43px;
}

.card-container {
  padding: 0px 43px;
}

.card {
  background-color: #fff;
  border-radius: 5px;
  padding:12px 5px;
  text-align: center;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  margin: 30px 0;
}

.card:nth-child(1) {
  margin: 0px 0px 0 0;
}

.card-header {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 48px;
  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-icon {
  /*width: 40px;*/
  /*height: 40px;*/
  /*border-radius: 50%;*/
  /*margin: 0 auto 20px;*/
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: #007bff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  margin:18px auto 30px auto;
}

.card-icon img {
  width: 25px;
  height: 25px;
  position: relative;
  top: 5px;
}

.card-icon i {
  font-size: 20px;
}

.card-price {
  font-size: 20px;
  font-weight: 400;

  color: rgba(11, 22, 43, 1);
  text-align: center;
  vertical-align: top;
}

.card-price span:last-child {
  font-size: 20px;
}

.card-subtext {
  color: #777;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 30px;

  text-align: center;
  vertical-align: top;
}

.subscribe-btn {
  padding: 5px 30px;
  border: 1px solid #ccc;
  border-radius: 20px;
  background-color: white;
  cursor: pointer;
  text-align: center;
  margin: 25px 0;
}

.subscribe-btn:hover {
  color: white;
  background-color: #ccc;
}

.active {
  background-color: #147cf5;
  color: white;
  border-color: #147cf5;
}

.active:hover {
  background-color: white;
  color: #007bff;
}

.dark {
  background-color: #333;
  color: white;
  border-color: #333;
}

.dark:hover {
  color: #333;
  background-color: white;
}

.feedback-container {
  font-family: YourFontName2;
  padding: 10px 43px;
}

.feedback-container p {
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 20px;
  vertical-align: top;
  font-family: YourFontName2;
}

.kk {
  color: #147cf5;
  border: 1px solid gray;
  width: 50px;
  height: 30px;
  text-align: left;
  margin: 0;
  background-color: #e5e5e5;
  color: black;
  border-radius: 10px;
  padding: 0px 50px 0px 10px;
  vertical-align: middle;
}

.input-group {
  margin-top: 20px;
}

.input-group input {
  padding: 5px 0px 5px 10px;
  color: white;
  background-color: #333333;
  border-radius: 2px 0px 0px 2px;
  border: none;
  border-radius: 2px;
  color: gray;
  margin: 10px 5px;
}

.input-group button {
  padding: 5px 15px 5px 15px;
  background-color: #147cf5;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 12px;
  width: 200px;
  margin: 10px 0;
}

.input-group button:hover {
  color: #147cf5;
  background-color: white;
}

.login-container {
  text-align: center;
  color: white;
  background-color: black;
  padding: 100px 0;
  width: 80%;
  margin: 0 auto;
}

.bg1 {
  background-color: black;
  padding: 0px 43px;
}

.headbanner h1 {
  font-size: 50px;
  text-align: center;
  color: white;
  padding: 200px 0px 0px 0px;
}

.headbanner p {
  font-size: 16px;
  text-align: center;
  color: white;
  padding: 50px 0px 100px 0px;
}

.headbanner {
  text-align: center;
}

.slider {
  overflow: hidden;
}

.slider-wrapper {
  display: flex;

  transition: transform 1s ease;
}

.slide p {
  color: gray;
  font-size: 15px;
  font-family: YourFontName2;
  text-align: left;
  padding: 20px 0;
}

.slide img {
  width: auto;
  object-fit: cover;
}

.headtext {
  color: white;
  font-size: 25px;
  text-align: center;
  vertical-align: top;
  padding: 30px 0;
}

.headtext span {
  background: linear-gradient(to left,
      rgba(76, 142, 212, 1),
      rgba(128, 99, 220, 1),
      rgba(173, 63, 226, 1));
  /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
  background-clip: text;
  /*将设置的背景颜色限制在文字中*/
  -webkit-text-fill-color: transparent;
  /*给文字设置成透明*/
}

.colorb {
  color: #6600ff;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 15px;
  border-radius: 50%;
}

.image-desc {
  padding-top: 15px;
  color: #85858A;
}

.arrow-button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: #343334;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
  transition: all 0.5s ease;
}

.arrow-button:hover {
  background-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.parents {
  text-align: right;
  height: 50px;
}
</style>
